import { css } from '@/styled-system/css';

export const prevStyles = css.raw({
  position: 'absolute',
  top: '50%',
  left: '400',
  padding: '400',
  transform: 'translateY(-50%)',
  _mobile: { display: 'none' },
});

export const nextStyles = css.raw({
  position: 'absolute',
  top: '50%',
  right: '400',
  padding: '400',
  transform: 'translateY(-50%)',
  _mobile: { display: 'none' },
});
